// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { SearchRequestBase } from "./base/search-request-base";

export class ProductSearchRequest extends SearchRequestBase {
	public override BasicSearchName: string = "";
	public override BasicSearchDescription: string = "";
	public ProductCategoryIds: string = "";
}